export default function NotPost() {
    return (
        <div className="postArticle article">
            <div className="container">
            <h1 className="bigTitle highlightError">Post Not Found 😮</h1>
            </div>
        </div>
    )
}